import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'

const useAction =
  ({ mutationFn, queryKey, message }) =>
  () => {
    const queryClient = useQueryClient()
    return useMutation({
      mutationFn: mutationFn,
      onSuccess: (res) => {
        if (res.message && res.success) {
          toast.success(res.message)
        } else if (message) {
          toast.info(message)
        }
        queryClient.invalidateQueries(queryKey.lists())
        if (res?._id) {
          queryClient.invalidateQueries(queryKey.detail(res?._id))
        }
      },
      onError: (error) => {
        // if (error.message) {
        //   toast.error(error.message)
        // }
      },
    })
  }

export default useAction
